import React, { useState } from "react";
import { uri } from "../../../../../help/Api";
import useFetchObjectByPost from "../../../../../components/Hooks/useFetchObjectByPost";
import { useEffect } from "react";
import { insh, sto } from "../../../../../Context/InshData";
import BackdropScI from "../../../../../services/BackdropScI";
import EReceiptVoucher from "./EReceiptVoucher";
import dataF from "../../../../../Server/dataF.json"
import LoadingPage from "../../../../../services/LoadingPage";


function EReceiptVoucherItem(props){
  const [branch, setBranch] = useState({ id: -1, name: "الكل" });
  const tb = {
    wait: true,
    Branch: true,
    defaultCenterUser:true,
    stor: { ...sto, branchi: branch.id == -1 ? sto.branchi : branch.id },
    parms: { 
        branch: branch.id == -1 ? sto.branchi : branch.id ,
        iempid: sto.empi,
     },

  };

  const { object: AutoOptionsB, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
    [branch]
  );

    const tttb ={
    /*other:true,*/ // out
    wait:true,
    other:true,
    Users:true,
    Stocks:true, // Error // out
    Banks:true,
    Customers:true,
    // salesmen:true,
    costcenters:true,
    // Employees:true,
    CheckStatus:true,
    omlat: true,
    stor:sto,
    PermissionsElemnts:true,
    /*params*/ // out
    parms:{
      // ibranchid:sto.branchi, 
      ibranchid:branch.id == -1 ? sto.branchi : branch.id , 

      iempid:sto.empi,
      iuserid:sto.idi, 
      scurrenciestype:'I',
      branch:branch.id == -1 ? sto.branchi : branch.id ,
      tname:"sandq",
      withOmlat : true,
      iformid: dataF[66].id,
    },
    autos:{
      Users:true,
      Safes:true,
      Stocks:true,
      Banks:true,
      // Employees:true,
      // salesmens:true,
      costcenters: true,
      CheckStatus: true,
      omlat: true,

    }
  }

  
  const { object: AutoOptions, fetching: fetchinData } = useFetchObjectByPost(
    uri + "Res",
    tttb,
    [branch]
  );
    // const url = uri+'Res';

    // const {object:AutoOptions, fetching: fetchinData, fetch:fetchURL} = 
    //  useFetchObjectByPost(url, tttb,    [branch]
    //  );
    
    
      if(fetchinData || !AutoOptions?.Customers ||!AutoOptionsB?.Branches )
        // return <BackdropScI />
      return <LoadingPage />
    return (
        <EReceiptVoucher
        {...{
            AutoOptions: AutoOptions?.Customers? AutoOptions: [],
            // fetchURL,
            prmis: AutoOptions?.permisElm?? insh.permiElm,
            ...props,
            isDialogData:false,
            AutoOptionsB: AutoOptionsB?.Branches? AutoOptionsB: [],
            branch,
            setBranch,
        }}/>
    )
}

export default function EReceiptVoucherCon(){

    return (
      
        <EReceiptVoucherItem
        {...{
          isDialog: false,
            
        }}/>
    )
}

export function EReceiptVoucherLink(props){
  const {data: item, onClose,} = props;

  useEffect(()=>{
    console.log('customer',item)
})
    return (
        <EReceiptVoucherItem
        {...{
            isDialog: true,
            item,
            onClose,

        }}/>
    )
}
